import { EUploadTypes } from '@enums/common';

export const FILE_ACCEPT_BY_TYPE: Record<EUploadTypes, string> = {
  [EUploadTypes.Image] : 'image/*',
  [EUploadTypes.All]   : '.xlsx,.xls,.doc,.docx,.txt,.pdf,.djvu,image/*',
};
